import { render } from "./ReturnConfirmModal.vue?vue&type=template&id=49c9530a&ts=true"
import script from "./ReturnConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ReturnConfirmModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__